var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-footer', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-column justify-content-center align-items-center align-items-sm-start align-items-md-start align-items-lg-start align-items-xl-start pl-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logo,
      "alt": "Cyber Integrity Initiative",
      "max-width": "270",
      "contain": ""
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function () {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "grey lighten-5"
          }
        })], 1)];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "text-body-2 text-description mt-2"
  }, [_vm._v(" INNOVATION. CYBERSECURITY. COMPLIANCE. ")])], 1), _c('v-col', {
    attrs: {
      "sm": "4"
    }
  }), _c('v-col', {
    staticClass: "text-follow-us text-center d-flex justify-content-center align-items-center flex-column flex-md-row",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-row', {
    staticClass: "p-2 justify-content-center",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_c('v-col', {
    staticClass: "d-flex align-items-center justify-content-end pl-0 pr-1",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v("FOLLOW US ON")]), _c('v-col', {
    staticClass: "d-flex justify-content-start align-items-center pl-1",
    attrs: {
      "cols": "5"
    }
  }, _vm._l(_vm.socialIcons, function (icon) {
    return _c('v-btn', {
      key: icon.id,
      attrs: {
        "icon": "",
        "href": icon.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "object-fit": "contain",
        "max-width": "30px"
      },
      attrs: {
        "src": icon.svg,
        "alt": icon.altText
      }
    })]);
  }), 1)], 1)], 1)], 1), _c('v-divider', {
    staticClass: "my-4"
  }), _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    staticClass: "mr-2 text-underline-links",
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show('modal-privacy');
      }
    }
  }, [_vm._v("PRIVACY POLICY")]), _c('v-btn', {
    staticClass: "text-underline-links",
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showFooterOverlay = true;
      }
    }
  }, [_vm._v("DISCLAIMER")])], 1), _c('v-col', {
    staticClass: "text-question justify-content-center text-left d-flex align-items-center mb-3 mb-lg-0 mb-xl-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', [_vm._v("ANY QUESTIONS? ASK HERE >")])])], 1), _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "text-center d-flex align-items-center justify-content-center p-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-copyright d-flex align-items-center"
  }, [_vm._v(" © " + _vm._s(_vm.currentYear) + " Copyright. Project Spectrum. All Rights Reserved. ")])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFooterOverlay,
      expression: "showFooterOverlay"
    }],
    staticClass: "modal-window-overlay"
  }, [_c('div', {
    staticClass: "modal-window-display"
  }, [_c('div', {
    staticClass: "disclaimer-navbar"
  }, [_c('div', {
    staticClass: "container-fluid disclaimer-navbar-content"
  }, [_c('v-row', {
    staticClass: "disclaimer-navbar-row"
  }, [_c('v-col', {
    staticClass: "m-0 p-0 h-100",
    attrs: {
      "cols": _vm.isMobileView ? 10 : 11
    }
  }, [_c('div', {
    staticClass: "container-fluid h-100 d-flex justify-content-center align-items-center"
  }, [_c('v-row', {
    staticClass: "h-100 d-none d-lg-flex d-xl-flex"
  }, [_c('v-col', {
    staticClass: "p-0 d-flex justify-content-center align-items-center",
    style: {
      color: _vm.selectedDisclaimerNavItem === 'General' ? '#FFCD00' : '#FFFFFF'
    },
    attrs: {
      "cols": "2.4"
    },
    on: {
      "click": function ($event) {
        _vm.selectedDisclaimerNavItem = 'General';
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("General")])]), _c('v-col', {
    staticClass: "p-0 d-flex justify-content-center align-items-center",
    style: {
      color: _vm.selectedDisclaimerNavItem === 'Training Content' ? '#FFCD00' : '#FFFFFF'
    },
    attrs: {
      "cols": "2.4"
    },
    on: {
      "click": function ($event) {
        _vm.selectedDisclaimerNavItem = 'Training Content';
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("Training Content")])]), _c('v-col', {
    staticClass: "p-0 d-flex justify-content-center align-items-center",
    style: {
      color: _vm.selectedDisclaimerNavItem === 'Cyber Adviser' ? '#FFCD00' : '#FFFFFF'
    },
    attrs: {
      "cols": "2.4"
    },
    on: {
      "click": function ($event) {
        _vm.selectedDisclaimerNavItem = 'Cyber Adviser';
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("Cyber Adviser")])]), _c('v-col', {
    staticClass: "p-0 d-flex justify-content-center align-items-center",
    style: {
      color: _vm.selectedDisclaimerNavItem === 'Useful Tools' ? '#FFCD00' : '#FFFFFF'
    },
    attrs: {
      "cols": "2.4"
    },
    on: {
      "click": function ($event) {
        _vm.selectedDisclaimerNavItem = 'Useful Tools';
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("Useful Tools")])]), _c('v-col', {
    staticClass: "p-0 d-flex justify-content-center align-items-center",
    style: {
      color: _vm.selectedDisclaimerNavItem === 'LLA' ? '#FFCD00' : '#FFFFFF'
    },
    attrs: {
      "cols": "2.4"
    },
    on: {
      "click": function ($event) {
        _vm.selectedDisclaimerNavItem = 'LLA';
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("LLA")])])], 1), _c('v-row', {
    staticClass: "m-0 h-100 d-none d-sm-flex d-md-none d-flex d-sm-none d-md-flex d-lg-none d-xl-none"
  }, [_c('v-col', {
    staticClass: "h-100 m-0 p-0 d-flex justify-column-start align-items-center",
    attrs: {
      "cols": "2"
    }
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-backdrop",
      modifiers: {
        "sidebar-backdrop": true
      }
    }],
    staticClass: "navbar-toggler ml-2 p-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showDisclaimerNavigationMenu
    }
  }, [_c('i', {
    class: {
      'mdi mdi-menu': !_vm.isDisclaimerMobileMenuOpened,
      'mdi mdi-close': _vm.isDisclaimerMobileMenuOpened
    }
  })])]), _c('v-col', {
    staticClass: "project-spectrum-image",
    attrs: {
      "cols": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo/PSLogo-Desktop.png"),
      "alt": ""
    }
  })])], 1)], 1)]), _c('v-col', {
    staticClass: "p-0 d-flex justify-content-center align-items-center",
    attrs: {
      "cols": _vm.isMobileView ? 2 : 1
    }
  }, [_c('div', {
    staticClass: "modal-window-close-container"
  }, [_c('button', {
    staticClass: "modal-window-close-container-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.showFooterOverlay = false;
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  })])])])], 1)], 1)]), _c('div', {
    staticClass: "modal-window-body"
  }, [_c('div', {
    staticClass: "container-fluid p-0"
  }, [!_vm.isDisclaimerMobileMenuOpened && !_vm.hasDisclaimerButtons || !_vm.isMobileView ? _c('v-row', {
    staticClass: "disclamer-body-content"
  }, [_c('v-col', {
    staticClass: "h-100 d-none d-lg-flex d-xl-flex",
    staticStyle: {
      "padding-right": "0",
      "padding-left": "30px"
    },
    attrs: {
      "lg": "4",
      "xl": "4"
    }
  }, [_c('div', {
    staticClass: "w-100 h-100 d-flex flex-column"
  }, [_c('div', {
    staticClass: "disclaimer-title-section"
  }, [_c('span', {
    staticClass: "modal-window-title-text"
  }, [_vm._v(_vm._s(_vm.disclaimerTitleText))])]), _c('div', {
    staticClass: "disclaimer-button-section"
  }, _vm._l(_vm.disclaimerTitleButtons, function (button) {
    return _c('v-btn', {
      key: button.title,
      staticClass: "mb-5",
      attrs: {
        "outlined": "",
        "rounded": "",
        "width": "280",
        "color": _vm.navControlTitleSelection[_vm.selectedDisclaimerNavItem].selectedTextContent === button.title ? _vm.primaryYellowColor : _vm.primaryWhiteColor
      },
      on: {
        "click": function ($event) {
          return _vm.setActiveDisclaimerButtonText(button.title);
        }
      }
    }, [_vm._v(" " + _vm._s(button.title) + " ")]);
  }), 1)])]), _c('v-col', {
    staticClass: "m-0 p-0 d-none d-sm-flex d-md-none d-flex d-sm-none d-md-flex d-lg-none d-xl-none",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "w-100 pl-4 pt-3 d-flex flex-row justify-content-start align-items-center"
  }, [_c('span', {
    staticClass: "modal-window-title-text",
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(" " + _vm._s(_vm.disclaimerTitleText) + " ")])])]), _c('v-col', {
    staticClass: "h-100 d-flex justify-content-center",
    class: {
      'align-items-center': !_vm.isMobileView,
      'align-items-start': _vm.isMobileView
    },
    attrs: {
      "cols": "12",
      "lg": "8",
      "xl": "8"
    }
  }, [_c('div', {
    staticClass: "modal-window-text-content",
    style: {
      height: _vm.isMobileView ? '92%' : '97%'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.disclaimerText)
    }
  })])], 1) : _vm._e(), (_vm.isDisclaimerMobileMenuOpened || _vm.hasDisclaimerButtons) && _vm.isMobileView ? _c('v-row', {
    staticClass: "m-0 p-0 h-100 d-none d-sm-flex d-md-none d-flex d-sm-none d-md-flex d-lg-none d-xl-none",
    staticStyle: {
      "border-bottom-left-radius": "20px",
      "border-bottom-right-radius": "20px"
    },
    style: {
      backgroundColor: _vm.hasDisclaimerButtons ? 'transparent' : '#424EC4'
    }
  }, [!_vm.hasDisclaimerButtons ? _c('v-col', {
    staticClass: "d-flex flex-column justify-column-start",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-center align-items-center",
    staticStyle: {
      "height": "70px"
    },
    style: {
      color: _vm.selectedDisclaimerNavItem === 'General' ? '#FFCD00' : '#FFFFFF'
    },
    on: {
      "click": function () {
        return _vm.disclaimerNavigationClickHandler('General');
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("General")])]), _c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-center align-items-center",
    staticStyle: {
      "height": "70px"
    },
    style: {
      color: _vm.selectedDisclaimerNavItem === 'Training Content' ? '#FFCD00' : '#FFFFFF'
    },
    on: {
      "click": function () {
        return _vm.disclaimerNavigationClickHandler('Training Content');
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("Training Content")])]), _c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-center align-items-center",
    staticStyle: {
      "height": "70px"
    },
    style: {
      color: _vm.selectedDisclaimerNavItem === 'Cyber Adviser' ? '#FFCD00' : '#FFFFFF'
    },
    on: {
      "click": function () {
        return _vm.disclaimerNavigationClickHandler('Cyber Adviser');
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("Cyber Adviser")])]), _c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-center align-items-center",
    staticStyle: {
      "height": "70px"
    },
    style: {
      color: _vm.selectedDisclaimerNavItem === 'Useful Tools' ? '#FFCD00' : '#FFFFFF'
    },
    on: {
      "click": function () {
        return _vm.disclaimerNavigationClickHandler('Useful Tools');
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("Useful Tools")])]), _c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-center align-items-center",
    staticStyle: {
      "height": "70px"
    },
    style: {
      color: _vm.selectedDisclaimerNavItem === 'LLA' ? '#FFCD00' : '#FFFFFF'
    },
    on: {
      "click": function () {
        return _vm.disclaimerNavigationClickHandler('LLA');
      }
    }
  }, [_c('span', {
    staticClass: "disclaimer-navbar-text"
  }, [_vm._v("LLA")])])]) : _vm.hasDisclaimerButtons ? _c('v-col', {
    staticClass: "d-flex flex-column justify-column-start",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "disclaimer-button-section pt-5"
  }, _vm._l(_vm.disclaimerTitleButtons, function (button) {
    return _c('v-btn', {
      key: button.title,
      staticClass: "mb-5",
      attrs: {
        "outlined": "",
        "rounded": "",
        "width": "280",
        "color": _vm.navControlTitleSelection[_vm.selectedDisclaimerNavItem].selectedTextContent === button.title ? '#FFCD00' : '#ffffff'
      },
      on: {
        "click": function ($event) {
          return _vm.setActiveDisclaimerButtonText(button.title);
        }
      }
    }, [_vm._v(" " + _vm._s(button.title) + " ")]);
  }), 1)]) : _vm._e()], 1) : _vm._e()], 1)])])]), _c('b-modal', {
    attrs: {
      "id": "modal-privacy",
      "title": "Privacy Policy",
      "size": "xl"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "dark"
          },
          on: {
            "click": function ($event) {
              return _vm.$bvModal.hide('modal-privacy');
            }
          }
        }, [_vm._v(" Close ")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.privacyContent)
    }
  })]), _c('a', {
    staticClass: "back_top",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-up"
  })])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }